import { render, staticRenderFns } from "./ClockConfig.vue?vue&type=template&id=112ed1a1"
import script from "./ClockConfig.vue?vue&type=script&lang=js"
export * from "./ClockConfig.vue?vue&type=script&lang=js"
import style0 from "./ClockConfig.vue?vue&type=style&index=0&id=112ed1a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports